import styled, { css, keyframes } from "styled-components";
import { color } from "../../styles";
import { Backdrop } from "@mui/material";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
    to {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
`;

export const ModalWrapper = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  max-width: 550px;
  max-height: 700px;
  transform: translate(-50%, -50%) scale(${({ isOpen }) => (isOpen ? 1 : 0.5)});
  background-color: ${color.emphasis.NEUTRAL_N0};
  padding: 24px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  gap: 32px;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  animation: ${({ isOpen }) =>
    isOpen
      ? css`
          ${fadeIn} 0.3s ease-out forwards
        `
      : css`
          ${fadeOut} 0.3s ease-out forwards
        `};
  
  @media (max-width: 768px) {
        padding: 16px;
        width: 95%;
    }
`;

export const StyledBackdrop = styled(Backdrop)`
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
`;

export const TitleWrapper = styled.div`
  text-align: left;
`;

export const TitleText = styled.div`
  font-family: "Noto Sans";
  color: ${color.secondary.CHARCOAL};
  font-size: 22px;
  font-weight: 700;
  padding-top: 12px;

  @media (max-width: 768px) {
        font-size: 20px;
    }
`;

interface WarningTextProps {
  paddingTop: string;
}

export const WarningText = styled.div<WarningTextProps>`
font-family: "Noto Sans";
color: ${color.secondary.CHARCOAL};
font-size: 16px;
font-weight: 400;
padding-top: ${({ paddingTop }) => paddingTop};
line-height: 1.5;

@media (max-width: 768px) {
  font-size: 14px;
}
`;

export const ReasonText = styled.div`
  font-family: "Noto Sans";
  color: ${color.secondary.CHARCOAL};
  font-size: 16px;
  font-weight: bold; /* Set font weight to bold */
  padding-top: 24px;
  line-height: 1.5;
  margin-bottom: 8px;

  @media (max-width: 768px) {
        font-size: 14px;
    }   
        
  .required-asterisk {
        color: ${color.primary.RED};
    }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 12px;

    button {
        width: 100% !important;
        }
    }
`;
